import React from 'react';

export function formatTwoDecimals(num) {
  try {
    num = num.toFixed(2);
    return num;
  } catch (e) {
    return num;
  }
}
